"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceBreakSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductPriceBreakSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductPriceBreakSearchResponse = ProductPriceBreakSearchResponse;
//# sourceMappingURL=product-price-break-search.response.js.map